export default __webpack_public_path__ + "461d68605cec43d6f5d657a073cc2265.png";